import { render, staticRenderFns } from "./StatusCardsList.vue?vue&type=template&id=0cd63bca&"
import script from "./StatusCardsList.vue?vue&type=script&lang=js&"
export * from "./StatusCardsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cd63bca')) {
      api.createRecord('0cd63bca', component.options)
    } else {
      api.reload('0cd63bca', component.options)
    }
    module.hot.accept("./StatusCardsList.vue?vue&type=template&id=0cd63bca&", function () {
      api.rerender('0cd63bca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dashboard/dashboardComponents/StatusCardsList.vue"
export default component.exports